import { render, staticRenderFns } from "./OrderDeliver.vue?vue&type=template&id=3f88dc12&scoped=true"
import script from "./OrderDeliver.vue?vue&type=script&lang=js"
export * from "./OrderDeliver.vue?vue&type=script&lang=js"
import style0 from "./OrderDeliver.vue?vue&type=style&index=0&id=3f88dc12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f88dc12",
  null
  
)

export default component.exports